<template>
  <div class="p-8 max-w-3xl flex-no-grow">
    <FullCalendar
      :events="eventSources"
      :config="config"
    />
  </div>
</template>

<script type="text/babel">
import { FullCalendar } from 'vue-full-calendar'
import moment from 'moment'

export default {
  name: 'CalendarView',
  components: {
    FullCalendar,
  },
  data() {
    return {
      config: {
        editable: false,
        defaultView: 'month',
        timeFormat: window.calendarViewFormat,
        eventColor: '#074BC3',
        header: {
          left:   'prev,next today',
          center: 'title',
          right:  '',
        },
        dayClick: (momentDate, jsEvent, view) => {
          let dateQueryParam = ''

          if (momentDate.isAfter(moment())) {
            dateQueryParam = `start_date=${momentDate.format('YYYY-MM-DD')}`
          }

          window.location.href = this.$urlGenerator.active(`calendar/events/create?${dateQueryParam}`)
        },
      },
    }
  },
  computed: {
    eventSources() {
      return {
        events: (start, end, timezone, callback) => {
          this.$api
            .active()
            .get(`calendar/events`, {
              params: {
                timezone: timezone,
                start: start.format('YYYY-MM-DD'),
                end: end.format('YYYY-MM-DD'),
              },
            })
            .then((response) => {
              callback(response.data.data.map((event) => {
                return {
                  start: event.attributes.start_date,
                  end: event.attributes.end_date,
                  url: this.$urlGenerator.active(`calendar/events/${event.uuid}`),
                  title: event.attributes.title,
                  allDay: event.attributes.all_day,
                }
              }))
            })
            .catch((errors) => {
              this.$store.commit('baseAddNotification', {
                type: 'error',
                title: 'Error',
                text: 'There was a problem requesting your calendars',
                timeout: false,
              })
            })
        },
      }
    },
  },
}
</script>
